module.exports = __webpack_public_path__ + "images/dir-lanhu@2x-f16911e05d0ce73e7caee7dbcab5b06a.png";